<template>
    <ui-dropdown placement="bottom-start" :menu-class="menuClass" trigger-class="flex-1" :enabled="enabled"
                 ref="dropdown">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 overflow-y-auto w-full border-b border-gray-300 flex">
                <input v-model="innerQuery" @input="setQuery(innerQuery)"
                       ref="searchInput"
                       class="flex-grow relative rounded-md shadow-sm block w-full border text-sm focus:outline-none focus:ring-brand focus:border-brand"
                       style="margin: 0px!important;"/>
                <div class="flex-shrink ml-2 flex items-center justify-center">
                    <div class="border border-gray-300 rounded-md px-1 py-1.5 bg-gray-white text-gray-500 hover:text-blue-500">
                        <span class="fas fa-warehouse" @click="clear(close)"></span>
                    </div>
                </div>
            </div>
            <div class=" p-3 max-h-64 overflow-y-auto w-full z-30">
                <!-- Empty State. -->
                <div v-if="!query" class="text-gray-500 text-sm">
                    Start typing to search for Packages...
                </div>
                <!-- Results -->
                <div v-else class="space-y-6">
                    <div v-if="packageItems.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Packages</div>
                        <div class="space-y-1">
                            <div
                                v-for="packageItem in packageItems"
                                class="flex packageItems-center space-x-2 text-left w-full rounded-md px-1 py-0 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="packageItem.name"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">
                                        <div class="truncate text-sms mx-0 pt-0.5 p-0.5">
                                            <button
                                                @mousedown="selectExistingItem(packageItem, close)"
                                                class="flex truncate px-1 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                            >
                                                <span class="flex-1 w-full mr-1 relative truncate">
                                                {{ packageItem.name }}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="(packageItems.length ===0)" class="text-gray-500 text-sm">
                        No matching Packages found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import UiInput from "../../ui/UiInput.vue";
import {PackageNew} from "@models";

export default {
    components: {UiInput},
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
        menuClass: {
            type: String,
            default: 'w-full',
        },
        current: '',
        enabled: true,
    },
    data() {
        return {
            innerQuery: this.current,
            query: this.current,
            packageItems: [],
            packages: [],
        }
    },
    computed: {},
    methods: {
        matchContact(packageItem) {
            const query = (''+this.query).toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return query.every((token) => {
                return (packageItem.reference + ' ' + packageItem.name).toLowerCase().includes(token)
            });
        },
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        async setQuery(query, open = true) {
            this.packages = await PackageNew.search(query);
            this.query = query
            let options = []
            this.packages.forEach((packageItem, key) => {
                if (this.matchContact(packageItem)) {
                    options.push(packageItem);
                }
            })
            this.packageItems = options.slice(0, 50);
            if (open) {
                this.$refs.dropdown.close();
                this.$refs.dropdown.open();
            }
        },
        async selectExistingItem(packageItem, close) {
            this.$emit('selected:existingPackageItem', {packageItem});
            this.query = packageItem.name;
            this.innerQuery = this.query;
            close();
            await this.setQuery(this.innerQuery, false);
        },
        clear(close) {
            this.$emit('selected:existingPackageItem', {});
            this.query = '';
            this.innerQuery = '';
            close();
        },
        close() {
            this.$refs.dropdown.close();
        },
        focus() {
            this.$refs.searchInput.focus();
        }
    },
    async mounted() {
        if (this.innerQuery) {
            await this.setQuery(this.innerQuery, false);
        }
    },
    beforeDestroy() {
        this.$refs.dropdown.close();
    }
}
</script>
